import { IconNames, Text, SvgIcon } from '@cinch-labs/design-system'

import styles from './icon-with-text.module.css'
export interface IconWithTextProps {
  icon: keyof typeof IconNames
  text: string
}

export const IconWithText = ({ icon, text }: IconWithTextProps) => (
  <div className={styles.container}>
    <SvgIcon name={icon} size={16} />
    <Text className={styles.text}>{text}</Text>
  </div>
)
